import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getAppealFineHeaderEditorDataAction } from '../../../store/profile/action';
import BaseModal, { BaseModalContent } from "../BaseModal";
import { Button, Grid, TextField } from '@material-ui/core';
import { appealReplyCitation } from '../../../store/citationDetail/action';
const useStyles = makeStyles((theme) => ({
    bluetitle: {
        width: '100%',
        height: '100px'
    }, 
  }));

const AppealedReplyCitationModal = (props) => {
    const classes = useStyles();
    const { isOpenReplyCitationModal, handleCloseAppealedReplyCitationModal, citationDetailState } = props;
    const dispatch = useDispatch();
    const { customer } = useParams();

    const [form, setForm] = useState({
        subject: 'N/A',
        body: ''
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const citationReply = {...form, citationId:citationDetailState?.id}
    const handleSubmit = () => {
        dispatch(appealReplyCitation(citationReply))
        handleCloseAppealedReplyCitationModal();
    };

    useEffect(() => {
        if (customer) {
            dispatch(getAppealFineHeaderEditorDataAction(customer));
        }
    }, [customer, dispatch]);

    return (
        <BaseModal
            title="Send Reply Citation"
            open={isOpenReplyCitationModal}
            onClose={handleCloseAppealedReplyCitationModal}
            fullWidth
        >
            <BaseModalContent>
                <Grid container spacing={2} align='left'>
                    <Grid item xs={12}>
                        <TextField id="body" name="body" label="Body" variant="outlined" value={form.body}
                        className={classes.bluetitle}
                            onChange={handleChange}
                             />
                    </Grid>
                    <Grid container spacing={2} justify="flex-end">
                        <Grid item >
                            <Button onClick={handleCloseAppealedReplyCitationModal}>Cancel</Button>
                        </Grid>
                        <Grid item >
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSubmit}
                                disabled={!form.body}
                            >
                                Send
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </BaseModalContent>
        </BaseModal>
    );
};

export default AppealedReplyCitationModal;
